import React, { useEffect, useState } from "react";
import Icon from "@mui/material/Icon";
import Divider from "@mui/material/Divider";
import PropTypes from "prop-types";
import toast from "react-hot-toast";
import { Controller, useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import MenuItem from "@mui/material/MenuItem";
import { FormControl, InputLabel, Select } from "@mui/material";
import Grid from "@mui/material/Grid";
import { mdrMasterModel, mdrMasterSchema } from "../../../../models/binMaster";
import ConfiguratorRoot from "../../../../examples/Configurator/ConfiguratorRoot";
import MDBox from "../../../../components/MDBox";
import MDTypography from "../../../../components/MDTypography";
import MDInput from "../../../../components/MDInput";
import MDButton from "../../../../components/MDButton";
import useApi from "../../../../components/Utils/api";
import OutlinedInput from "@mui/material/OutlinedInput";



function MdrConfigurator({ openConfigurator, setOpenConfigurator, master, getMasters }) {
  const [merchants, setMerchants] = useState([]);
  const [defaultMasters, setDefaultMasters] = useState([]);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    trigger,
    watch,
    control,
    setValue
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(mdrMasterSchema)
  });

  useEffect(() => {
    getAllReqInfoMaster();
    if (Object.keys(master).length > 0) {
      reset(master);
    } else {
      getDefaultMasters();
      reset(mdrMasterModel);
    }
  }, [master]);

  const api = useApi();

  const getAllReqInfoMaster = () => {
    const data = {
      "mid": "",
      "ownerName": "",
      "referenceId": ""
    };
    api.post("/merchant/browse", data)
      .then(response => {
        if (response.data.statusCodeValue === 200) {
          setMerchants(response.data.body);
        }
      })
      .catch(error => {
        // Handle error
      });
  };

  const getDefaultMasters = () => {
    api.post("master/getDefaultMdrMaster")
      .then((response) => {
        if (response.data.statusCodeValue === 200) {
          setDefaultMasters(response.data.body[0]);
          reset(response.data.body[0]);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 403) {
          toast.error("You do not have permission to perform this action.");
          return;
        }
        toast.error(error.response.data.body);
      });
  };

  const createTerminalHandler = (data) => {
    api.post("master/createMdrMaster", data)
      .then((response) => {
        if (response.status === 200) {
          toast.success("MDR master successfully created.");
          setOpenConfigurator(false);
          getMasters();
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 403) {
          toast.error("You do not have permission to perform this action.");
          return;
        }
        console.log(error.response);
        if (error.response.status === 406) {
          toast.error(error.response.data.body)
        }
      });
  };

  function updateTerminalHandler(data) {
    api.put("master/mdrMaster/" + master.mcId, data)
      .then(response => {
        if (response.data.statusCodeValue === 200) {
          toast.success("MDR master successfully updated.");
          reset(mdrMasterModel);
          setOpenConfigurator(false);
          getMasters();
        }
      })
      .catch(error => {
        console.log(error);
      });
  }

  function submitHandler() {
    if (Object.keys(master).length === 0) {
      handleSubmit(createTerminalHandler)();
    } else {
      handleSubmit(updateTerminalHandler)();
    }
  }

  const handleMdrTypeChange = (event) => {
    const selectedMdrType = event.target.value;
    // Depending on the selected MDR type, set visibility of form fields
    if (selectedMdrType === "Blended") {
      setValue("cardHoldercharger", ""); // Reset value of hidden field
    } else if (selectedMdrType === "IC++") {
      // Reset values of hidden fields
      setValue("cardHoldercharger", "");
      setValue("merchantMDr", "");
      setValue("settlementType", "");
      setValue("mid", "");
    }
  };

  return (
    <ConfiguratorRoot variant="permanent" ownerState={{ openConfigurator }} configuratorwidth={500}>
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems="baseline"
        pt={4}
        pb={0.5}
        px={3}
      >
        <MDBox>
          <MDTypography variant="h5">{Object.keys(master).length > 0 ? 'Update' : 'New'} MDR Master</MDTypography>
        </MDBox>
        <Icon
          sx={({ typography: { size }, palette: { dark, white } }) => ({
            fontSize: `${size.lg} !important`,
            color: dark.main,
            stroke: "currentColor",
            strokeWidth: "2px",
            cursor: "pointer",
            transform: "translateY(5px)",
          })}
          onClick={() => setOpenConfigurator(false)}
        >
          close
        </Icon>
      </MDBox>
      <Divider />
      <Grid container spacing={2} justifyContent="center">
        <FormProvider {...{ register, handleSubmit, reset, formState: { errors }, trigger, watch, control }}>
          <Grid item xs={6}>
            <FormControl fullWidth style={{ height: '100%' }}>
              <InputLabel id="mdr-label">Mdr Type</InputLabel>
              <Controller
                name="mdrType"
                control={control}
                defaultValue=""
                onChange={handleMdrTypeChange}
                render={({ field }) => (
                  <Select {...field} style={{ height: '100%' }} labelId="settlement-label" input={<OutlinedInput label="Settlement Type" />}>
                    <MenuItem value="">- Select Type -</MenuItem>
                    <MenuItem value="Blended"> Blended</MenuItem>
                    <MenuItem value="IC++">IC++ </MenuItem>
                  </Select>
                )}
              />
            </FormControl>
          </Grid>
          {watch("mdrType") === "Blended" && (
            <>
                            <Grid item xs={6}>
                <MDInput
                  type="text"
                  label="Card Holder Charge (%)"
                  name="cardHoldercharger"
                  error={errors.cardHoldercharger}
                  helperText={errors.cardHoldercharger ? errors.cardHoldercharger.message : ''}
                  fullWidth

                  {...register("cardHoldercharger")}
                />
              </Grid>
              <Grid item xs={6}>
                <MDInput
                  type="text"
                  label="Merchant MSF (%)"
                  name="merchantMDr"
                  error={errors.merchantMDr}
                  helperText={errors.merchantMDr ? errors.merchantMDr.message : ''}
                  fullWidth
                  
                  {...register("merchantMDr")}
                />
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth style={{ height: '100%' }}>
                  <InputLabel id="settlement-label">Settlement Type</InputLabel>
                  <Controller
                    name="settlementType"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <Select {...field} style={{ height: '100%' }} labelId="settlement-label" input={<OutlinedInput label="Settlement Type" />}>
                        <MenuItem value="">- Select Merchant -</MenuItem>
                        <MenuItem value="GROSS"> Gross Settlement </MenuItem>
                        <MenuItem value="NET"> Net Settlement </MenuItem>
                      </Select>
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth style={{ height: '100%' }}>
                  <InputLabel id="bank-label">Merchant</InputLabel>
                  <Controller
                    name="mid"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <Select {...field} style={{ height: '100%' }} labelId="bank-label" input={<OutlinedInput label="Merchant" />}>
                        <MenuItem value="">- Select Merchant -</MenuItem>
                        {merchants.map(merchant => <MenuItem key={merchant.mid} value={merchant.mid}>{merchant.companyName}</MenuItem>)}
                      </Select>
                    )}
                  />
                </FormControl>
              </Grid>
            </>
          )}
          {watch("mdrType") === "IC++" && (
  <>
    <Grid item xs={6}>
      <FormControl fullWidth style={{ height: '100%' }}>
        <InputLabel id="settlement-label">Settlement Type</InputLabel>
        <Controller
          name="settlementType"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <Select {...field} style={{ height: '100%' }} labelId="settlement-label" input={<OutlinedInput label="Settlement Type" />}>
              <MenuItem value="">- Select Merchant -</MenuItem>
              <MenuItem value="GROSS"> Gross Settlement </MenuItem>
         
            </Select>
          )}
        />
      </FormControl>
    </Grid>
    <Grid item xs={12}>
    <MDTypography variant="body2" gutterBottom>
      Cardholder Surcharge:
    </MDTypography>
  </Grid>
    <Grid item xs={6}>
      <MDInput
        type="text"
        label="eftpos ($)"
        name="eftpos"
        error={errors.eftpos}
        helperText={errors.eftpos ? errors.eftpos.message : ''}
        fullWidth
        required
        {...register("eftpos")}
      />
    </Grid>
    <Grid item xs={6}>
      <MDInput
        type="text"
        label="Visa Credit (%)"
        name="visaCredit"
        error={errors.visaCredit}
        helperText={errors.visaCredit ? errors.visaCredit.message : ''}
        fullWidth
        required
        {...register("visaCredit")}
      />
    </Grid>
    <Grid item xs={6}>
      <MDInput
        type="text"
        label="Visa Debit (%)"
        name="visaDebit"
        error={errors.visaDebit}
        helperText={errors.visaDebit ? errors.visaDebit.message : ''}
        fullWidth
        required
        {...register("visaDebit")}
      />
    </Grid>
    <Grid item xs={6}>
      <MDInput
        type="text"
        label="MasterCard Credit (%)"
        name="masterCredit"
        error={errors.masterCredit}
        helperText={errors.masterCredit ? errors.masterCredit.message : ''}
        fullWidth
        required
        {...register("masterCredit")}
      />
    </Grid>
    <Grid item xs={6}>
      <MDInput
        type="text"
        label="MasterCard Debit (%)"
        name="masterDebit"
        error={errors.masterDebit}
        helperText={errors.masterDebit ? errors.masterDebit.message : ''}
        fullWidth
        required
        {...register("masterDebit")}
      />
    </Grid>
    <Grid item xs={6}>
      <MDInput
        type="text"
        label="AMEX (%)"
        name="amex"
        error={errors.amex}
        helperText={errors.amex ? errors.amex.message : ''}
        fullWidth
        required
        {...register("amex")}
      />
    </Grid>
    <Grid item xs={6}>
      <MDInput
        type="text"
        label="UPI (%)"
        name="upi"
        error={errors.upi}
        helperText={errors.upi ? errors.upi.message : ''}
        fullWidth
        required
        {...register("upi")}
      />
    </Grid>
    <Grid item xs={6}>
      <MDInput
        type="text"
        label="Diners (%)"
        name="diners"
        error={errors.diners}
        helperText={errors.diners ? errors.diners.message : ''}
        fullWidth
        required
        {...register("diners")}
      />
    </Grid>
    <Grid item xs={6}>
      <MDInput
        type="text"
        label="JCB (%)"
        name="jcb"
        error={errors.jcb}
        helperText={errors.jcb ? errors.jcb.message : ''}
        fullWidth
        required
        {...register("jcb")}
      />
    </Grid>
    <Grid item xs={6}>
      <FormControl fullWidth style={{ height: '100%' }}>
        <InputLabel id="bank-label">Merchant</InputLabel>
        <Controller
          name="mid"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <Select {...field} style={{ height: '100%' }} labelId="bank-label" input={<OutlinedInput label="Merchant Name" />}>
              <MenuItem value="">- Select Merchant -</MenuItem>
              {merchants.map(merchant => <MenuItem key={merchant.mid} value={merchant.mid}>{merchant.companyName}</MenuItem>)}
            </Select>
          )}
        />
      </FormControl>
    </Grid>
    
    <Grid item xs={12}>
    <MDTypography variant="body2" gutterBottom>
    Merchant Service Fee:
    </MDTypography>
  </Grid>


    <Grid item xs={6}>
      <MDInput
        type="text"
        label="eftpos ($)"
        name="eftposMsf"
        error={errors.eftposMsf}
        helperText={errors.eftposMsf ? errors.eftposMsf.message : ''}
        fullWidth
        required
        {...register("eftposMsf")}
      />
    </Grid>
    <Grid item xs={6}>
      <MDInput
        type="text"
        label="Others (%)"
        name="others"
        error={errors.others}
        helperText={errors.others ? errors.others.message : ''}
        fullWidth
        required
        {...register("others")}
      />
    </Grid>
  
    
  </>
)}

          <Grid item xs={12}>
            <MDButton onClick={() => submitHandler()} variant="gradient" color="info" style={{ float: 'right' }}>
              {Object.keys(master).length > 0 ? 'Update' : 'Add'}
            </MDButton>
          </Grid>
        </FormProvider>
      </Grid>
    </ConfiguratorRoot>
  );
}

MdrConfigurator.defaultProps = {
  openConfigurator: false,
  setOpenConfigurator: false,
  getMasters: false,
  master: {}
}

MdrConfigurator.propTypes = {
  openConfigurator: PropTypes.bool,
  setOpenConfigurator: PropTypes.func,
  getMasters: PropTypes.func,
  master: PropTypes.object
}

export default MdrConfigurator;
